import { Button } from 'antd';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
    IconUserList,
    IconDepartmentList,
    IconMyCompany,
} from '../../assets/Images/icons/icon-landing';
import UserService from '../../services/UserService';
import { ROUTER } from '../../constants/router';
import { useEffect } from 'react';
import IconPermission from '../../assets/Images/icons/icon-permission';
import usePermission from '../../hooks/usePermission';

const LandingPage = () => {
    // Role
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);
    useEffect(() => {
        if (!admin) {
            navigate(`/not-found`);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [admin]);

    const { t, i18n } = useTranslation();

    const { isAuditor, isUser } = usePermission();

    const navigate = useNavigate();
    const itemList = [
        {
            title: t('My Company'),
            text: t('Manage my company'),
            icon: <IconMyCompany />,
            link: '',
            onClick: () =>
                navigate(`${ROUTER.CONFIGURATION.USER_MANAGEMENT}/my-company`),
            linkText: t('landing.StartNow'),
            hidden: isUser,
        },
        {
            title: t('common.DepartmentList'),
            text: t('landing.DepartmentListDes'),
            icon: <IconDepartmentList />,
            link: '',
            onClick: () =>
                navigate(
                    `${ROUTER.CONFIGURATION.USER_MANAGEMENT}/department-list`
                ),
            linkText: t('landing.StartNow'),
            hidden: false,
        },
        {
            title: t('Permission'),
            text: t('landing.Permissions'),
            icon: <IconPermission />,
            link: '',
            onClick: () =>
                navigate(`${ROUTER.CONFIGURATION.USER_MANAGEMENT}/permissions`),
            linkText: t('landing.StartNow'),
            hidden: isUser,
        },
        {
            title: t('common.UserList'),
            text: t('landing.UserListDes'),
            icon: <IconUserList />,
            link: '',
            onClick: () =>
                navigate(`${ROUTER.CONFIGURATION.USER_MANAGEMENT}/user-list`),
            linkText: t('landing.StartNow'),
            hidden: false,
        },
    ];

    const disabled = () => {
        if (isUser) return false;
        if (isAuditor) return true;
    };

    return (
        <div className="bg-gray-body">
            {/* <HeaderLayout /> */}
            <div className="title ">{t('User Management')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('common.Configuration')} /
                </span>
                <span> {t('User Management')}</span>
            </div>
            <div className="w-full text-center">
                <div className="container mx-auto p-8 px-5 xl:mt-24">
                    <div className="grid my-auto mx-auto grid-cols-1 md:grid-cols-1 xl:grid-cols-4 2xl:grid-cols-4 gap-4 w-4/4">
                        {itemList.map((item) => {
                            if (item.hidden) return null;
                            return (
                                <div
                                    className="grid grid-rows-2 w-full mx-auto group px-8 rounded-2xl transform duration-500 hover:-translate-y-2 cursor-pointer bg-white"
                                    key={item.title}
                                >
                                    <div className="w-32 h-20 m-auto">
                                        {item.icon}
                                    </div>
                                    <div className="pt-6 pb-12">
                                        <div className="text-xl font-semibold py-4">
                                            {item.title}
                                        </div>
                                        <div>{item.text}</div>
                                    </div>
                                    <div className="mb-8">
                                        <Button
                                            disabled={disabled()}
                                            onClick={item.onClick}
                                            size="large"
                                            type="primary"
                                            className={classNames({
                                                'px-8': i18n.language === 'th',
                                            })}
                                        >
                                            {item.linkText}
                                        </Button>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LandingPage;
